module.exports = __webpack_public_path__ + "static/media/error.831f7382.svg";